import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import {
	EDIT_ESTIMATE_LOCATION,
	PRICING_DETAILS_PRODUCT_AREA,
} from './trackingConstants';

export const useTrackEditEstimateCTA = () => {
	const { track } = useAnalyticsContext();

	return useCallback(() => {
		track({
			event: AnalyticsConstants.BUTTON_CLICKED,
			properties: {
				product_area: PRICING_DETAILS_PRODUCT_AREA,
				button_action: 'Edit estimate',
				location: EDIT_ESTIMATE_LOCATION,
			},
		});
	}, [track]);
};
